import { BreedSegmentationIds } from 'constants/segmentation';
import { PetProfile } from 'types/pet-profile';
import { omitNullableHandler } from 'utils/type-helper';

/**
 * Check if petProfile has enough properties for API
 * Works for both dog and cat profiles in a type-safe manner
 *
 * For dogs, checks: selectedAge, selectedBreed, selectedNeeds
 * For cats, checks: selectedAge, selectedNeeds
 */
export default function isPetProfileEmpty({
  petProfile,
}: {
  petProfile?: PetProfile;
}): boolean {
  if (!petProfile) {
    return true;
  }

  const keysToCheck =
    petProfile.petType === 'dog'
      ? (['selectedAge', 'selectedBreed', 'selectedNeeds'] as const)
      : (['selectedAge', 'selectedNeeds'] as const);

  return (
    keysToCheck
      .map((key) => petProfile[key])
      .filter((v) => typeof v !== 'boolean')
      .flat()
      .filter((v) => v !== BreedSegmentationIds.OtherBreed)
      .filter(omitNullableHandler).length === 0
  );
}
